import { render, staticRenderFns } from "./InsView.vue?vue&type=template&id=11345f63&scoped=true&"
import script from "./InsView.vue?vue&type=script&lang=js&"
export * from "./InsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11345f63",
  null
  
)

export default component.exports